import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'

export const Container = styled.div`
  /*display: flex;
  align-items: center;
  justify-content: space-between;*/
  display: grid;
  grid-template-columns: 1fr 4rem 1fr;
  gap: 1rem;
  width: 100%;
  padding: 0.3rem;
  font-weight: 800;
  border-radius: 1rem;
  text-align: center;

  a {
    text-decoration: none;
  }
  > a {
    justify-self: stretch;
  }
  > span {
    justify-self: stretch;
  }

  @media (min-width: 375px) {
    gap: 2rem;
    > a {
      justify-self: stretch;
    }
    > span {
      justify-self: stretch;
    }
  }
`

export const Button = styled.span<{ $isNext?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.4em 0;
  border-radius: 1rem;
  border: 1px solid var(--text-color);
  height: 4rem;
  opacity: 0.5;
  background: white;
  font-size: 1.3rem;

  ${mq.small} {
    font-size: 1.6rem;
    padding: 0.4em 1.2em;
  }

  &:before {
    content: '';
    display: block;
    width: 1.4rem;
    aspect-ratio: 1;
    margin: -0.14em 1rem 0 -0.8em;
    mask: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.5 12L14.5 17V7L9.5 12Z' fill='%232E3A59'/%3E%3C/svg%3E%0A")
      center center / contain no-repeat;
    mask: url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.4966 4.5C13.7727 4.5 13.9966 4.27614 13.9966 4C13.9966 3.72386 13.7727 3.5 13.4966 3.5L13.4966 4.5ZM0.646457 3.64641C0.451194 3.84167 0.451193 4.15825 0.646454 4.35352L3.82843 7.53551C4.02369 7.73077 4.34027 7.73077 4.53553 7.53551C4.7308 7.34025 4.7308 7.02366 4.53553 6.8284L1.70712 3.99997L4.53555 1.17155C4.73081 0.976286 4.73081 0.659703 4.53555 0.46444C4.34029 0.269178 4.02371 0.269177 3.82845 0.464438L0.646457 3.64641ZM13.4966 3.5L1.00001 3.49996L1.00001 4.49996L13.4966 4.5L13.4966 3.5Z' fill='%231A3948'/%3E%3C/svg%3E%0A")
      center center / contain no-repeat;
    background-color: currentColor;
  }

  ${props =>
    props.$isNext &&
    css`
      flex-direction: row-reverse;

      &::before {
        transform: rotate(180deg);
        margin-right: -0.8em;
        margin-left: 1rem;
      }
    `}

  &:is(a span) {
    cursor: pointer;
    transition: 0.2s background-color;
    opacity: 1;

    &:hover {
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
`

export const Home = styled.div`
  border-radius: 1rem;
  border: 1px solid var(--text-color);
  height: 4rem;
  background: white;

  a {
    display: block;
    padding: 0.9rem;
  }

  svg {
    width: 2rem;
  }
`
